<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { type ExhibitionData, getExhibitionDataList } from '@/api/exhibition';
import { DetailCard } from './components/detail-card';
import { useRoute } from 'vue-router';
import { LazyContainer } from '@/components';
import { Tabbar } from './components/tabbar';
import { List } from 'vant';

const route = useRoute();
const enterpriseId = route.params.enterpriseId as string;
const externalId = route.params.externalId as string;

const page = ref(1);
const pageSize = 10;
const noMore = ref(false);

const exhibitionDataList = ref<ExhibitionData[]>([]);

onMounted(async () => {
  exhibitionDataList.value = await getExhibitionDataList({
    enterpriseId,
    externalId
  });
});

const loading = ref(false);
const loadNextPage = async () => {
  page.value += 1;
  const result = await getExhibitionDataList({
    enterpriseId,
    externalId,
    page: page.value,
    pageSize
  });
  noMore.value = result.length < pageSize;
  exhibitionDataList.value = [...exhibitionDataList.value, ...result];
};

async function loadMore() {
  await loadNextPage();
  loading.value = false;
}
</script>

<template>
  <div :class="$style.cardContainer">
    <LazyContainer>
      <List
        :class="$style.listContainer"
        v-model:loading="loading"
        :finished="noMore"
        finished-text="没有更多了"
        @load="loadMore"
        :immediate-check="false"
      >
        <div :class="$style.cardList">
          <DetailCard
            v-for="data of exhibitionDataList"
            :key="data.id"
            :data="data"
          />
        </div>
      </List>
    </LazyContainer>
    <Tabbar />
  </div>
</template>

<style module>
.cardContainer {
  margin-top: 10px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.cardList {
  padding: 10px;
  width: 100%;
  display: grid;
  gap: 10px;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: minmax(100px, auto) 1fr;
}
</style>
